export default "__VITE_ASSET__C$aopX5C__"